import React from 'react'

function Team() {
    const css_padding ={paddingTop: '50px'}
  return (
    <div id="team" className="basic-2">
    <div className="container">
      <h1 className="blue text-center">Leadership Team</h1>
      <div className="row">
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-1.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Dr. Newtoni</h4>
              <span>Chief Technology Officer & AI Architect</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-2.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Ms. Araeus</h4>
              <span>Head of AI Solutions & Business Intelligence</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-3.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Mr. Concolor</h4>
              <span>Director of Blockchain Technology & Security</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-4.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Ms. Amurensis</h4>
              <span>VP of Customer Success & Implementation</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-5.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Ms. Femoralis</h4>
              <span>Lead AI Agent Developer & MCP Specialist</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6 d-flex" style={css_padding}>
          <div className="team-member">
            <div className="member-img">
              <img src="images/team-6.jpg" className="img-fluid" alt="" />
            </div>
            <div className="member-info">
              <h4>Mr. Jugger</h4>
              <span>Director of Enterprise Solutions & Strategy</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Team